"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgHelp(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M15 15.198C15 11.733 16.724 10 20.171 10c5.171 0 5.892 5.364 3.568 7.513-1.504 1.391-2.243 1.317-3.239 2.987-.374.627-.6 2.53-.5 4.5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M21 29a1 1 0 10-2 0h2zm-2 1a1 1 0 102 0h-2zm0-1v1h2v-1h-2z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgHelp;
//# sourceMappingURL=Help.js.map